// extracted by mini-css-extract-plugin
module.exports = {"notification":"_827c64","icon":"_3e831d","errorMark":"_ee7b3d","successMark":"_367419","content":"_a03465","message":"_4f75c3","action":"_5c4b22","dismiss":"_9c7550"};